var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3488_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0ZM6.7292 4.2952C5.752 4.6892 4.9492 5.4888 4.5468 6.462C4.2444 7.1768 4.1712 7.9804 4.3092 8.7416C4.5056 9.8296 5.186 10.816 6.1256 11.3964C6.8412 11.8472 7.7032 12.0564 8.5456 11.9888C9.49 11.9264 10.4 11.5012 11.0688 10.8332C10.6624 10.4172 10.248 10.0088 9.8364 9.598C9.3388 10.0788 8.624 10.3368 7.9344 10.2308C7.4224 10.1632 6.9392 9.91 6.5904 9.5292C6.1196 9.03 5.9016 8.3036 6.0224 7.6276C6.1008 7.1308 6.3588 6.6672 6.7324 6.332C7.2432 5.8616 7.9816 5.652 8.6632 5.7888C9.1068 5.8668 9.5096 6.0976 9.8364 6.4032C10.2488 5.9928 10.6612 5.5824 11.07 5.168C10.6468 4.7496 10.1332 4.4208 9.57 4.2252C8.6572 3.9012 7.6252 3.9264 6.7292 4.2952Z",
    fill: "#1652F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7292 4.29517C7.6252 3.92637 8.6572 3.90117 9.57 4.22517C10.1332 4.42077 10.6468 4.74957 11.07 5.16797C10.6612 5.58237 10.2488 5.99277 9.8364 6.40317C9.5096 6.09757 9.1068 5.86677 8.6632 5.78877C7.9816 5.65197 7.2432 5.86157 6.7324 6.33197C6.3588 6.66717 6.1008 7.13077 6.0224 7.62757C5.9016 8.30357 6.1196 9.02997 6.5904 9.52917C6.9392 9.90997 7.4224 10.1632 7.9344 10.2308C8.624 10.3368 9.3388 10.0788 9.8364 9.59797C10.248 10.0088 10.6624 10.4172 11.0688 10.8332C10.4 11.5012 9.49 11.9264 8.5456 11.9888C7.7032 12.0564 6.8412 11.8472 6.1256 11.3964C5.186 10.816 4.5056 9.82957 4.3092 8.74157C4.1712 7.98037 4.2444 7.17677 4.5468 6.46197C4.9492 5.48877 5.752 4.68917 6.7292 4.29517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3488_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.4c869886d9df9ae8627a4a04d3a3179f.svg";
export { ForwardRef as ReactComponent };